import React from 'react'
import Link from 'gatsby-link'

const NotPublished = ({ lang }) => {
	if (lang === 'es') {
	return (
		<div className="page notpublished">
			<h1>Esta ubicación ya no está disponible...</h1>
			<p>
				Dale click para <Link to={`/${lang}/contact`}>contactarnos</Link>
			</p>
			<div>
				<h3>Servicio las 24 horas, los 365 días del año</h3>
				<div><a href="tel:+5072638777">+507 263–8777</a></div>
				<div><a href="tel:+5072942341">+507 294-2341</a></div>
			</div>
		</div>
	)		
	}
	return (
		<div className="page notpublished">
			<h1>This location is no longer available...</h1>
			<p>
				Click here to <Link to={`/${lang}/contact`}>contact us</Link>
			</p>
			<div>
				<h3>24-hour service, 365 days a year</h3>
				<div><a href="tel:+5072638777">+507 263–8777</a></div>
				<div><a href="tel:+5072942341">+507 294-2341</a></div>
			</div>
		</div>
	)
}

export default NotPublished



// WEBPACK FOOTER //
// ./src/components/NotPublishedLocation.js